import { Button } from '@affine/component';
import { useI18n } from '@affine/i18n';
import { PlusOutlined, PullRequestOutlined } from '@ant-design/icons'

import * as styles from './tag-list-header.css';

export const TagListHeader = ({ onOpen }: { onOpen: () => void }) => {
  const t = useI18n();
  return (
    <div className={styles.tagListHeader}>
      <div className={styles.tagListHeaderTitle}>
        <PullRequestOutlined />
        {t['Tags']()}
      </div>
      <Button
        className={styles.newTagButton}
        onClick={onOpen}
        data-testid="all-tags-new-button"
        style={{ background: '#1c64ff', color: 'white', padding: '7px 15px' }}
      >
        <PlusOutlined style={{ marginRight: '5px' }} />
        {t['com.affine.tags.empty.new-tag-button']()}
      </Button>
    </div>
  );
};
